module.exports = __webpack_public_path__ + "img/lianxi.c1f969c3.png";